import * as React from 'react';

const TechnicalProblemIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} aria-label="Technical problem icon">
    <g data-name="Group 1704">
      <g data-name="Group 348">
        <g data-name="Group 347">
          <path
            data-name="Path 238"
            d="M10.928 6.258v6.645a1.1 1.1 0 002.148 0V6.258a1.1 1.1 0 00-2.148 0z"
            fill="#0a1514"
          />
        </g>
      </g>
      <path
        data-name="Path 239"
        d="M11.159 16.712a.074.074 0 010 .024c.013-.094.027-.191.038-.285a.674.674 0 01-.019.07c.035-.086.073-.172.107-.258a.124.124 0 01-.024.04l.169-.218a.3.3 0 01-.051.051l.218-.169a.157.157 0 01-.04.024l.258-.107a.225.225 0 01-.07.019c.094-.014.191-.027.285-.038a.162.162 0 01-.051 0c.094.013.191.027.285.038a.677.677 0 01-.07-.019l.258.107a.122.122 0 01-.04-.024l.217.169a.3.3 0 01-.051-.051l.169.218a.159.159 0 01-.024-.04c.035.086.073.172.107.258a.227.227 0 01-.019-.07c.013.094.027.191.038.285a.166.166 0 010-.051c-.013.094-.027.191-.038.285a.681.681 0 01.019-.07c-.035.086-.073.172-.107.258a.124.124 0 01.024-.04l-.169.218a.3.3 0 01.051-.051l-.217.169a.16.16 0 01.04-.024l-.258.108a.223.223 0 01.07-.019c-.094.013-.191.027-.285.037a.17.17 0 01.051 0c-.094-.013-.191-.027-.285-.037a.643.643 0 01.07.019l-.258-.108a.124.124 0 01.04.024l-.218-.169a.306.306 0 01.051.051l-.169-.218a.162.162 0 01.024.04c-.035-.086-.073-.172-.107-.258a.226.226 0 01.019.07c-.013-.094-.027-.191-.038-.285a.1.1 0 010 .027 1.145 1.145 0 00.314.76 1.087 1.087 0 00.76.314 1.1 1.1 0 00.76-.314 1.068 1.068 0 00.314-.76 1.367 1.367 0 00-.384-.924 1.3 1.3 0 00-1.847 0 1.362 1.362 0 00-.384.924 1.306 1.306 0 002.221.932 1.389 1.389 0 00.392-.932 1.075 1.075 0 00-1.834-.76 1.184 1.184 0 00-.312.76z"
        fill="#0a1514"
      />
      <g>
        <path
          data-name="Path 97"
          d="M24 12A12 12 0 1112 0a12 12 0 0112 12zm-1.92 0A10.08 10.08 0 1012 22.08 10.079 10.079 0 0022.08 12z"
          fill="#0a1514"
        />
      </g>
    </g>
  </svg>
);

export default TechnicalProblemIcon;
